/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Circle = ["svg", defaultAttributes, [["circle", { cx: "12", cy: "12", r: "10" }]]];

export { Circle as default };
//# sourceMappingURL=circle.js.map
